import React from "react";
import {
    ChevronLeftIcon,
    TimeIcon,
} from "../../../../helper/HwIcon";
import { convertToMinutesAndSeconds } from "../../../../helper/commonFunction";
import BookingStepProgress from "./BookingStepProgress";

const ReviewBookingBanner = ({
    currentTab,
    tab2SubStep = "review",
    timeRemaining,
    headerBackButtonFn,
}) => {
    const tab1Active = currentTab?.["1"]?.active;
    const tab2Active = currentTab?.["2"]?.active;

    if (!tab1Active && !tab2Active) return null;

    const title = tab1Active ? "Complete Your Booking" : "Complete Your Booking";

    return (
        <div className="hw-exchk--hero hw-hotel--hero hw-flight--hero">
            <div className="hw-exchk--heroInner">
                <button
                    type="button"
                    onClick={headerBackButtonFn}
                    className="hw-exchk--back"
                >
                    <ChevronLeftIcon />
                    Back
                </button>

                <div className="hw-exchk--heroBar">
                    <h1 className="hw-exchk--heroTitle">{title}</h1>

                    <div className="hw-hotel--heroTimer">
                        <TimeIcon />
                        Session expires in{" "}
                        {convertToMinutesAndSeconds(timeRemaining)}
                    </div>

                    <BookingStepProgress
                        currentTab={currentTab}
                        tab2SubStep={tab2SubStep}
                    />
                </div>
            </div>
        </div>
    );
};

export default React.memo(ReviewBookingBanner);
